import { Shield, Lock, CheckCircle, Award } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const items = [
  { icon: CheckCircle, label: "Microsoft AppSource" },
  { icon: Shield, label: "GDPR Compliant" },
  { icon: Lock, label: "Zero Retention" },
  { icon: Award, label: "EU Hosted" },
];

export const TrustBadges = () => {
  const { ref, animationClass } = useScrollAnimation<HTMLDivElement>({
    type: "fade",
    threshold: 0.3,
  });

  return (
    <section className="py-12 md:py-16 bg-background border-y border-border/60">
      <div className="container px-4">
        <div ref={ref} className={animationClass}>
          <p className="text-center text-[11px] font-mono uppercase tracking-widest text-muted-foreground mb-6 md:mb-8">
            Trusted standards
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5 md:gap-x-14">
            {items.map((it) => (
              <div
                key={it.label}
                className="flex items-center gap-2.5 text-muted-foreground hover:text-foreground transition-colors"
              >
                <it.icon className="w-5 h-5" strokeWidth={1.5} />
                <span className="text-sm font-medium tracking-tight">{it.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
